import { Theme, makeStyles } from "@material-ui/core/styles";

export const purchaseModalStyles = makeStyles((theme: Theme) => ({
  paymentModal: {
    "& .MuiDialog-paper": {
      margin: "12px",
    },
    "& .MuiDialog-paperWidthSm": {
      backgroundColor: "#ECF3F8",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "550px",
      },
      [theme.breakpoints.up("sm")]: {
        maxWidth: "540px",
      },
    },
    "& .MuiIconButton-label": {
      color: "#000000",
      "& svg.MuiSvgIcon-root": {
        fontSize: "2rem",
      },
    },
  },
  dialogContent: {
    padding: "0px 38px 20px",
    textAlign: "center",
  },
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "25px 0px 20px",
    height: "25px",
    "& button": {
      height: "20px",
    },
  },
  title: {
    color: "#000000",
    fontFamily: "Inter",
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    fontSize: 30,
  },
  subtitle: {
    color: "#000000",
    fontFamily: "Lato",
    fontSize: "18px",
    fontWeight: 500,
  },
  modalBody: {
    width: "100%",
    textAlign: "left",
  },
  contactSupport: {
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.only("xs")]: {
      flexDirection: "column",
    },
    marginTop: "20px",
    marginBottom: "20px",
    "& > *:first-child": {
      color: "#000000",
      fontFamily: "Lato",
      fontWeight: 400,
      marginBottom: "3px",
      [theme.breakpoints.only("xs")]: {
        fontSize: theme.typography.pxToRem(18),
      },
      [theme.breakpoints.up("sm")]: {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    "& a": {
      color: "#0344DC",
      marginLeft: "5px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontFamily: "Inter",
      fontWeight: 600,
      [theme.breakpoints.only("xs")]: {
        marginTop: "24px",
        marginLeft: "0px",
        fontSize: theme.typography.pxToRem(20),
      },
      [theme.breakpoints.up("sm")]: {
        fontSize: theme.typography.pxToRem(16),
      },
    },
  },
}));
